const translation = {
  title: 'Тестування вибірки',
  desc: 'Тестування ефективності пошуку знань на основі наданого текстового запиту.',
  dateTimeFormat: 'DD/MM/YYYY HH:mm A',
  recents: 'Останні',
  table: {
    header: {
      source: 'Джерело',
      text: 'Текст',
      time: 'Час',
    },
  },
  input: {
    title: 'Вихідний текст',
    placeholder: 'Будь ласка, введіть текст, рекомендується коротке декларативне речення.',
    countWarning: 'До 200 символів.',
    indexWarning: 'Тільки високоякісні знання.',
    testing: 'Тестування',
  },
  hit: {
    title: 'ВИБРАНІ АБЗАЦИ',
    emptyTip: 'Результати тестування вибірки відобразяться тут',
  },
  noRecentTip: 'Тут немає результатів останніх запитів',
  viewChart: 'ПЕРЕГЛЯНУТИ ВЕКТОРНУ ДІАГРАМУ',
  settingTitle: 'Налаштування отримання',
  viewDetail: 'Переглянути деталі',
  chunkDetail: 'Деталізація фрагмента',
  hitChunks: 'Натисніть {{num}} на дочірні шматки',
  open: 'Відкривати',
  keyword: 'Ключові слова',
  records: 'Записи',
}

export default translation
